module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.9860/js/img/upgrade-modal/crm_required_properties.svg"